const slider = [
    {
        title: "",
        description: "",
        
        image: "./home1.png",
    },

    {
        title: "",
        description: "",
        
        image: "./home2.jpg",

    },

    {
        title: "",
        description: "",
        
        image: "./inter4.jpg",
    },

    {
        title: "",
        description: "",
        
        image: "./work4.jpg",
    },

    {
        title: "",
        description: "",
        
        image: "./inter1.jpg",

    }
   
];

export default slider;